(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[844],{

/***/ 9818:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topic/[id]",
      function () {
        return __webpack_require__(5847);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4288);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1138);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6647);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4278);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5285);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2213);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9677);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment_timezone__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);




const SHOW_RESOURCES = 3;
const getInitials = function(name) {
    let separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : " ";
    return name.split(separator).map((part)=>{
        var _part_;
        return ((_part_ = part[0]) === null || _part_ === void 0 ? void 0 : _part_.toUpperCase()) || "";
    }).join("");
};
const truncateContent = (content, maxLength)=>{
    const text = content.replace(/<[^>]+>/g, ""); // Strip HTML tags
    return text.length > maxLength ? "".concat(text.substring(0, maxLength), "...") : text;
};
const MoreResources = (param)=>{
    let { filterId =[]  } = param;
    const [resources, setResources] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const [hasFetched, setHasFetched] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (!hasFetched) {
            const fetchResources = async ()=>{
                try {
                    const response = await fetch("/api/getBlogPosts");
                    const data = await response.json();
                    const filteredResources = data.filter((item)=>!filterId.includes(item.id)).sort(()=>0.5 - Math.random()).slice(0, SHOW_RESOURCES);
                    setResources(filteredResources);
                } catch (error) {
                    console.error("Failed to fetch resources:", error);
                }
            };
            fetchResources();
            setHasFetched(true); // Ensure fetch only happens once
        }
    }, [
        filterId,
        hasFetched
    ]); // `filterId` ensures the fetch updates if `filterId` changes
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        sx: {
            pb: 2
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                variant: "h4",
                gutterBottom: true,
                children: "Read Next"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                container: true,
                spacing: 2,
                sx: {
                    py: 2
                },
                children: resources.map((resource, idx)=>{
                    var _resource_images;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        md: 4,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                href: "/topic/" + resource.id,
                                children: [
                                    ((_resource_images = resource.images) === null || _resource_images === void 0 ? void 0 : _resource_images.length) > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        image: resource.images[0].url,
                                        sx: {
                                            height: 150,
                                            objectFit: "cover"
                                        }
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        component: "img",
                                        sx: {
                                            height: 150,
                                            objectFit: "contain"
                                        },
                                        image: "/KCC-Logo.webp"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        sx: {
                                            py: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                variant: "body1",
                                                noWrap: true,
                                                sx: {
                                                    width: "100%",
                                                    maxWidth: "100%"
                                                },
                                                children: resource.title
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                variant: "caption",
                                                children: resource.author.displayName || getInitials(resource.author.name)
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                variant: "caption",
                                                children: console.log(JSON.stringify(resource))
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                variant: "subtitle2",
                                                color: "text.secondary",
                                                component: "div",
                                                children: moment_timezone__WEBPACK_IMPORTED_MODULE_1___default()(resource.published).fromNow()
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }, "more_resources_card_".concat(idx));
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MoreResources);


/***/ }),

/***/ 9733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1391);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1138);
/* harmony import */ var _Utils_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7209);






const NextBreadcrumbs = (param)=>{
    let { title  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const [breadcrumbs, setBreadcrumbs] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (router) {
            const linkPath = router.asPath.split("/");
            linkPath.shift();
            const pathArray = linkPath.map((path, i)=>{
                return {
                    breadcrumb: path,
                    href: "/" + linkPath.slice(0, i + 1).join("/")
                };
            });
            setBreadcrumbs(pathArray);
        }
    }, [
        router
    ]);
    if (!breadcrumbs) {
        return null;
    }
    const breadcrumbsLength = breadcrumbs.length;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        "aria-label": "breadcrumb",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                underline: "hover",
                color: "inherit",
                href: "/",
                children: "Home"
            }),
            breadcrumbs.map((breadcrumb, i)=>{
                // const text = convertBreadcrumb(breadcrumb.breadcrumb);
                const text = (0,_Utils_utils__WEBPACK_IMPORTED_MODULE_4__/* .ConvertPathText */ .gO)(breadcrumb.breadcrumb);
                if (breadcrumbsLength - 1 == i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        color: "text.primary",
                        children: title ? title : text
                    }, "Breadcrumb_" + i);
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                    underline: "hover",
                    color: "inherit",
                    href: breadcrumb.href,
                    children: text
                }, "Breadcrumb_" + i);
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NextBreadcrumbs);


/***/ }),

/***/ 5847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _id_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Container/Container.js + 1 modules
var Container = __webpack_require__(4288);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Paper/Paper.js
var Paper = __webpack_require__(8881);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js
var Typography = __webpack_require__(1138);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(1953);
// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__(8);
var moment_timezone_default = /*#__PURE__*/__webpack_require__.n(moment_timezone);
// EXTERNAL MODULE: ./component/Page.jsx + 4 modules
var Page = __webpack_require__(4374);
// EXTERNAL MODULE: ./component/NextBreadcrumbs.jsx
var NextBreadcrumbs = __webpack_require__(9733);
// EXTERNAL MODULE: ./component/MoreResources.jsx
var MoreResources = __webpack_require__(1384);
// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(9238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./component/Utils/utils.js
var utils = __webpack_require__(7209);
// EXTERNAL MODULE: ./node_modules/react-share/es/FacebookShareButton.js
var FacebookShareButton = __webpack_require__(6573);
// EXTERNAL MODULE: ./node_modules/react-share/es/TwitterShareButton.js
var TwitterShareButton = __webpack_require__(6616);
// EXTERNAL MODULE: ./node_modules/react-share/es/LinkedinShareButton.js
var LinkedinShareButton = __webpack_require__(3597);
// EXTERNAL MODULE: ./node_modules/react-share/es/EmailShareButton.js
var EmailShareButton = __webpack_require__(8980);
// EXTERNAL MODULE: ./node_modules/react-share/es/FacebookIcon.js
var FacebookIcon = __webpack_require__(1020);
// EXTERNAL MODULE: ./node_modules/react-share/es/TwitterIcon.js
var TwitterIcon = __webpack_require__(7385);
// EXTERNAL MODULE: ./node_modules/react-share/es/LinkedinIcon.js
var LinkedinIcon = __webpack_require__(7332);
// EXTERNAL MODULE: ./node_modules/react-share/es/EmailIcon.js
var EmailIcon = __webpack_require__(6339);
;// CONCATENATED MODULE: ./utils/bioLookup.js
// add more if needed
const getBioRoute = (googleBloggerUid)=>{
    switch(googleBloggerUid){
        case "11134329999510677716":
            return "/bio/shane-holinde";
        case "18041335258965923566":
            return "/about";
        default:
            return null;
    }
};
/* harmony default export */ var bioLookup = (getBioRoute);

;// CONCATENATED MODULE: ./pages/topic/[id].js














const Article = ()=>{
    var _router_query, _post_author, _post_author1, _post_author2, _post_author3, _post_images_, _post_author4, _post_author_image, _post_author5;
    const router = (0,next_router.useRouter)();
    const articleId = router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.id;
    const [post, setPost] = (0,react.useState)(null);
    const url = (0,react.useRef)();
    (0,react.useEffect)(()=>{
        if (!articleId) {
            return;
        }
        fetch("/api/post/".concat(articleId)).then((res)=>res.json()).then((json)=>{
            setPost(json);
        });
        url.current = window.location.href;
    }, [
        router
    ]);
    if (post === null || post === void 0 ? void 0 : post.error) {
        router.push("/404");
    }
    if (post == null || !(post === null || post === void 0 ? void 0 : (_post_author = post.author) === null || _post_author === void 0 ? void 0 : _post_author.displayName)) {
        return;
    }
    // this santize html and restyle images
    const cleanedHTML = (()=>{
        if (!(post === null || post === void 0 ? void 0 : post.content)) {
            return null;
        }
        const tempElement = document.createElement("div");
        tempElement.innerHTML = browser_default().sanitize(post === null || post === void 0 ? void 0 : post.content);
        const images = tempElement.getElementsByTagName("img");
        for(let i = 0; i < images.length; i++){
            images[i].style.maxWidth = "100%";
            images[i].style.height = "auto";
        }
        const hyperlinks = tempElement.getElementsByTagName("a");
        for(let i1 = 0; i1 < hyperlinks.length; i1++){
            hyperlinks[i1].target = "_blank";
            hyperlinks[i1].rel = "noopener";
        }
        const modifiedHtmlString = tempElement.innerHTML;
        return modifiedHtmlString;
    })();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "".concat(post === null || post === void 0 ? void 0 : post.title, " | Kentucky Climate Center")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "An article about ".concat(post === null || post === void 0 ? void 0 : post.title, " by ").concat(post === null || post === void 0 ? void 0 : (_post_author1 = post.author) === null || _post_author1 === void 0 ? void 0 : _post_author1.displayName)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "author",
                        content: post === null || post === void 0 ? void 0 : (_post_author2 = post.author) === null || _post_author2 === void 0 ? void 0 : _post_author2.displayName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: "Kentucky Climate Center, Kentucky Mesonet, weather, climate, ".concat(post === null || post === void 0 ? void 0 : post.title, ", ").concat(post === null || post === void 0 ? void 0 : (_post_author3 = post.author) === null || _post_author3 === void 0 ? void 0 : _post_author3.displayName)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "".concat(post === null || post === void 0 ? void 0 : post.title, " | Kentucky Climate Center")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "kyclimate.org/topic/".concat(articleId)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "article"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: (0,utils/* getContentFromHtml */.jE)(cleanedHTML)
                    }),
                    (post === null || post === void 0 ? void 0 : post.images) && (post === null || post === void 0 ? void 0 : post.images.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: (_post_images_ = post.images[0]) === null || _post_images_ === void 0 ? void 0 : _post_images_.url
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                sx: {
                    pt: 10
                },
                elevation: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NextBreadcrumbs/* default */.Z, {
                        title: post === null || post === void 0 ? void 0 : post.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* default */.Z, {
                        sx: {
                            p: 5,
                            my: 3
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h2",
                                children: post === null || post === void 0 ? void 0 : post.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    cursor: "pointer"
                                },
                                onClick: ()=>{
                                    var _post_author;
                                    const route = bioLookup(post === null || post === void 0 ? void 0 : (_post_author = post.author) === null || _post_author === void 0 ? void 0 : _post_author.id);
                                    if (route !== null) {
                                        router.push(route);
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    sx: {
                                        display: "flex",
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: post === null || post === void 0 ? void 0 : (_post_author4 = post.author) === null || _post_author4 === void 0 ? void 0 : (_post_author_image = _post_author4.image) === null || _post_author_image === void 0 ? void 0 : _post_author_image.url.replace("//", "https://")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            sx: {
                                                pl: 1
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                    variant: "subtitle1",
                                                    children: [
                                                        "By ",
                                                        post === null || post === void 0 ? void 0 : (_post_author5 = post.author) === null || _post_author5 === void 0 ? void 0 : _post_author5.displayName
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                    variant: "subtitle2",
                                                    children: [
                                                        "Updated ",
                                                        moment_timezone_default()(post === null || post === void 0 ? void 0 : post.updated).toLocaleString()
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    py: 3
                                },
                                children: cleanedHTML && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: cleanedHTML
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h4",
                                        children: "Share"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookShareButton/* default */.Z, {
                                        url: url.current,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookIcon/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TwitterShareButton/* default */.Z, {
                                        url: url.current,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TwitterIcon/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkedinShareButton/* default */.Z, {
                                        url: url.current,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkedinIcon/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailShareButton/* default */.Z, {
                                        url: url.current,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailIcon/* default */.Z, {})
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreResources/* default */.Z, {
                filterId: [
                    post.id
                ]
            })
        ]
    });
};
/* harmony default export */ var _id_ = (Article);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,6770,9412,5446,6087,1352,4374,9774,2888,179], function() { return __webpack_exec__(9818); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);